import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { IBatonAuth } from 'src/app/models/baton-auth';
import { FolioDialogService } from 'src/app/modules/shared/folio-dialog-component/folio-dialog.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LabelConstants } from 'src/app/utilities/app-constants';
import { FolioHelperService } from 'src/app/utilities/folio-helper.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  readonly MY_CONSTANT = LabelConstants;

  labelHeading = ''; labelChangePasswordButton = ''; labelSuccess = ''; labelChangedPasswordSuccessfully = '';

  nameFormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  passwordFormControl = new FormControl('', [Validators.required]);
  newPasswordFormControl = new FormControl('', [Validators.required]);

  hidePassword = true;
  hideNewPassword = true;

  showErrorStatus = false;
  errorMessage = 'An error occurred';
  isMobileResolution;

  isSuccess = false;

  constructor(
    private folioHelperService: FolioHelperService,
    private dialogs: FolioDialogService,
    private authService: AuthenticationService
  ) {
    if (window.innerWidth < 768) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }

  }

  ngOnInit() {
    this.labelHeading = this.MY_CONSTANT.LABEL_HEADING_CHANGE_PASSWORD;
    this.labelChangePasswordButton = this.MY_CONSTANT.LABEL_BUTTON_CHANGE_PASSWORD;
    this.labelChangedPasswordSuccessfully = this.MY_CONSTANT.LABEL_PASSWORD_CHANGED;
    this.labelSuccess = this.MY_CONSTANT.LABEL_SUCCESS;

  }

  changePassword() {
    const uName = this.nameFormControl.value;
    const password = this.passwordFormControl.value;
    const newPassword = this.newPasswordFormControl.value;

    if (this.nameFormControl.invalid) {
      this.nameFormControl.markAsTouched();
      return;
    }

    if (this.passwordFormControl.invalid) {
      this.passwordFormControl.markAsTouched();
      return;
    }

    if (this.newPasswordFormControl.invalid) {
      this.newPasswordFormControl.markAsTouched();
      return;
    }

    this.folioHelperService.setSpinnerVisible(true);

    const user: IBatonAuth = {
      username: uName,
      password,
      newPassword
    };

    try {
      this.authService.changePassword(user).subscribe(
        (suc: IBatonAuth) => {
          // suc.statusCode = 1000;
          this.folioHelperService.setSpinnerVisible(false);
          if (suc.statusCode !== 1000) {
            this.showErrorStatus = true;
            this.errorMessage = suc.statusMessage;
            return;
          } else {
            setTimeout(() => {
              this.isSuccess = true;
            }, 100);
          }
        }, err => {
          this.showErrorStatus = true;
          this.errorMessage = err?.error?.message;
          this.folioHelperService.setSpinnerVisible(false);
          console.log('Error: ', err);
        }
      );
    } catch (changePasswordError) {
      this.folioHelperService.setSpinnerVisible(false);
      this.errorMessage = 'An Error occured';
    }

  }

}
